import { makeStyles } from '@material-ui/styles';
import { black } from '../../../constants/Colors';
import { primaryFontFamily } from '../../../constants/StyleConfig';

export default makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    activeArea: {
        display: 'flex',
        alignItems: 'center',
        cursor: ({ isMenuEmpty }) => (isMenuEmpty ? 'default' : 'pointer'),
    },
    arrowDropDown: {
        transition: 'transform linear 150ms',
        transform: ({ isOpen }) => (isOpen ? 'rotateX(180deg)' : 'none'),
    },
    option: {
        fontSize: '15px',
        fontFamily: primaryFontFamily,
    },
    imageIcon: {
        width: '26px',
        height: '26px',
        marginRight: ({ isMenuEmpty }) => (isMenuEmpty ? 24 : 0),
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        top: '30px',
        right: '5px',
    },
    chevron: {
        position: 'relative',
        '&:after': {
            content: '""',
            position: 'absolute',
            width: '0',
            height: '0',
            right: '-10px',
            top: '20px',
            borderLeft: '3px solid transparent',
            borderRight: '3px solid transparent',
            borderTop: `4px solid ${black}`,
        },
    },
}));
